module.exports = __webpack_public_path__ + "static/img/PK1.ee1070a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/PK1.jpg
// module id = Nxp0
// module chunks = 0